<div fxFlex.gt-sm="100%" class="p-10">
  <!-- <h3 class="m-0">Edit Tag</h3> -->
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div fxLayout="column wrap" fxFlexAlign="start">
      <mat-form-field>
        <mat-label>Rename</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>
      <!-- <div class="colour-picker fake-tag" [ngStyle]="{backgroundColor: colour ?? '#616161'}" fxFlex="none">
        Click to choose a colour
        <input matInput type="color" formControlName="colour">
      </div> -->
      <p>Background colour</p>
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" class="p-b-40">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <button type="button" mat-mini-fab [ngClass]="background('1')" (click)="setBackgroundColour('1')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('2')" (click)="setBackgroundColour('2')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('3')" (click)="setBackgroundColour('3')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('4')" (click)="setBackgroundColour('4')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('5')" (click)="setBackgroundColour('5')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('7')" (click)="setBackgroundColour('7')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('8')" (click)="setBackgroundColour('8')"> </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <button type="button" mat-mini-fab [ngClass]="background('9')" (click)="setBackgroundColour('9')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('10')" (click)="setBackgroundColour('10')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('11')" (click)="setBackgroundColour('11')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('12')" (click)="setBackgroundColour('12')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('13')" (click)="setBackgroundColour('13')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('14')" (click)="setBackgroundColour('14')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('15')" (click)="setBackgroundColour('15')"> </button>
        </div>
      </div>
      <p>Border colour</p>
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" class="p-b-40">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <button type="button" mat-mini-fab [ngClass]="background('1')" (click)="setBorderColour('1')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('2')" (click)="setBorderColour('2')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('3')" (click)="setBorderColour('3')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('4')" (click)="setBorderColour('4')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('5')" (click)="setBorderColour('5')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('7')" (click)="setBorderColour('7')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('8')" (click)="setBorderColour('8')"> </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <button type="button" mat-mini-fab [ngClass]="background('9')" (click)="setBorderColour('9')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('10')" (click)="setBorderColour('10')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('11')" (click)="setBorderColour('11')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('12')" (click)="setBorderColour('12')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('13')" (click)="setBorderColour('13')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('14')" (click)="setBorderColour('14')"> </button>
          <button type="button" mat-mini-fab [ngClass]="background('15')" (click)="setBorderColour('15')"> </button>
        </div>
      </div>
      <p>Preview</p>
      <div fxLayout="column" fxLayoutAlign="center center" class="p-b-10">
        <div class="fake-tag {{border(borderColour)}} {{background(backgroundColour)}}">
          {{form.get("name")?.value}}
        </div>
      </div>
    </div>
  </form>
  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" cdkFocusInitial class="p-t-30">
    <button mat-stroked-button color="basic" (click)="close()">
      <mat-icon>clear</mat-icon> Cancel
    </button>
    <button mat-flat-button color="warn" [mat-dialog-close]="true" (click)="onDeleteClick()">
      <mat-icon>delete</mat-icon> Delete
    </button>
    <button mat-flat-button color="primary" (click)="onSubmit()">
      <mat-icon>done</mat-icon> Save
    </button>
  </div>
</div>
